import React, { useContext, useState } from 'react';
import { observer } from 'mobx-react';
import EnterCode from '../EnterCode';
import { Box } from '@wix/design-system';
import { AppContextProvider } from '../AppLoader';
import { EnterCodeStore } from '../../stores/enterCode';
import { twoFactorDescriptionKeysMap } from '../../utils/constants';
import { EnterCodeContextProvider } from '../EnterCode/EnterCode';

const StepUpDialog: React.FC = observer(() => {
  const { rootStore } = useContext(AppContextProvider);
  const { stepUpAuthStore } = rootStore;
  const [enterCodeStore] = useState(new EnterCodeStore(rootStore));

  return (
    <EnterCodeContextProvider.Provider
      value={{ store: stepUpAuthStore, enterCodeStore }}
    >
      <Box direction="vertical" align="center" width="100%">
        <EnterCode
          store={stepUpAuthStore}
          dialogTitleKey="enter_code.title"
          descriptionKey={
            twoFactorDescriptionKeysMap[stepUpAuthStore.currentTwoFAMethod]
          }
          showBackButton={false}
        >
          <EnterCode.LinksSection>
            <EnterCode.VoiceCallLink />
          </EnterCode.LinksSection>
          <EnterCode.ButtonsSectionWithResend>
            <EnterCode.ButtonsSection.VerifyButton />
          </EnterCode.ButtonsSectionWithResend>
        </EnterCode>
      </Box>
    </EnterCodeContextProvider.Provider>
  );
});

export default StepUpDialog;
